export const isEndDateAfterStartDate = (
  start_datetime?: string | null,
  end_datetime?: string | null,
) => {
  if (!start_datetime || !end_datetime) {
    return true;
  }

  return new Date(end_datetime) > new Date(start_datetime);
};
